import { render, staticRenderFns } from "./TablaListaPrecio.vue?vue&type=template&id=d99481d4"
import script from "./TablaListaPrecio.vue?vue&type=script&lang=js"
export * from "./TablaListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports